"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var objectUtilities_1 = require("../../../util/objectUtilities");
var Icon_1 = require("../Icon/Icon");
var Tooltip_1 = require("../Tooltip/Tooltip");
var Checkbox_static_1 = require("./Checkbox.static");
var Checkbox_style_1 = __importDefault(require("./Checkbox.style"));
/**
 * Checkbox atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-inputs-checkbox--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Checkbox Source}
 */
exports.Checkbox = (0, react_1.forwardRef)(function (_a, ref) {
    var checked = _a.checked, children = _a.children, className = _a.className, disabled = _a.disabled, icon = _a.icon, _b = _a.labelPlacement, labelPlacement = _b === void 0 ? 'end' : _b, noCheckboxPadding = _a.noCheckboxPadding, onChange = _a.onChange, tooltip = _a.tooltip, value = _a.value, error = _a.error, rest = __rest(_a, ["checked", "children", "className", "disabled", "icon", "labelPlacement", "noCheckboxPadding", "onChange", "tooltip", "value", "error"]);
    var classes = (0, Checkbox_style_1.default)();
    var paddingClass = (function () {
        switch (labelPlacement) {
            case 'bottom':
                return classes.bottomLabelPadding;
            case 'end':
                return classes.endLabelPadding;
            case 'start':
                return classes.startLabelPadding;
            case 'top':
                return classes.topLabelPadding;
            default:
                return (0, objectUtilities_1.exhaustivenessCheck)(labelPlacement);
        }
    })();
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ text: tooltip }, { children: (0, jsx_runtime_1.jsx)(core_1.FormControlLabel, __assign({ ref: ref, control: (0, jsx_runtime_1.jsx)(core_1.Checkbox, { disableRipple: true, disabled: disabled, onChange: onChange, value: value, checked: checked !== false && checked !== Checkbox_static_1.CheckState.UNCHECKED, classes: {
                    root: (0, classnames_1.default)(classes.checkbox, !children || noCheckboxPadding ? classes.withoutLabelPadding : paddingClass, error && classes.hasError),
                    disabled: classes.disabled,
                }, className: classes.hover, icon: icon || ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.checkbox, color: disabled ? theme_1.default.colors.globalBackgroundDark : theme_1.default.colors.globalBackgroundLight, className: classes.checkboxIcon })), checkedIcon: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: checked === Checkbox_static_1.CheckState.PARTIAL ? icons_1.default.checkboxPartial : icons_1.default.checkboxChecked, color: theme_1.default.colors.primary, className: 'checkboxIconChecked' }) }), label: children, labelPlacement: labelPlacement, className: (0, classnames_1.default)('hoverable', classes.labelRoot, disabled && classes.disabledRoot, !children && classes.withoutLabelMargins, className) }, rest)) })));
});
